import Select from "react-select"
import { withRouter } from "react-router"
import { flowRight as compose } from "lodash"
import { Switch, Route } from "react-router-dom"
import React, { useState, useEffect } from "react"
import { useQuery, useMutation } from "@apollo/react-hooks"
import { Row, Col, Alert, FormGroup, Button } from "reactstrap"
import { userInfo, userRole, getOptions } from "utils"
import withModal from "components/modal"
import { Spinner } from "components/spinner"
import { SHOPPING_CART } from "components/layouts/gql"
import { withBasicNotify } from "components/notification"
import { useBread, withBreadcrumb } from "components/breadcrumb"
import ProductPrice from "./ProductPrice"
import ProductList from "./ProductListPageCl"
import ProductDetail from "./ProductDetailPageCl"
import ProductCategroies from "./ProductCategroies"
import {
  GET_PRODUCTS,
  GET_COMPANIES,
  GET_CATEGORIES,
  GET_SHOPPING_CART,
  ADD_PRODUCT_TO_SHOPPING_CART,
  SUM_PRODUCTS
} from "../../gql"

import "./style/style.scss"

const ProductCl = (props) => {
  const { data: companyData, loading: companyLoading } = useQuery(
    GET_COMPANIES,
    {
      skip:
        userInfo().role === userRole.CUSTOMER_PURCHASER ||
        userInfo().role === userRole.CUSTOMER,
      fetchPolicy: "network-only"
    }
  )

  const [selectedCompany, setSelectedCompany] = useState()
  const [shoppingCartId, setShoppingCartId] = useState()

  const { loading: shoopingCartLoading, refetch } = useQuery(
    GET_SHOPPING_CART,
    {
      skip:
        userInfo().role === userRole.SALES_ASSISTANT ||
        userInfo().role === userRole.SUPERVISOR,
      fetchPolicy: "network-only",
      variables: {
        ...(selectedCompany && { companyId: selectedCompany.value })
      }
    }
  )

  useEffect(() => {
    async function fetch() {
      const result = await refetch()
      setShoppingCartId(result.data.shoppingCart.id)
    }
    if (selectedCompany || userInfo().role === userRole.CUSTOMER_PURCHASER) {
      // Execute the created function directly
      fetch()
    }
  }, [refetch, selectedCompany])

  const [queryParam, setQueryParam] = useState({})
  const [pagination, setPagination] = useState({
    maxRowsOfPage: 6,
    currentPage: 0
  })

  const { data: productData, loading: productLoading, refetch: productRefecth } = useQuery(
    GET_PRODUCTS,
    {
      variables: { take: 6, skip: 0, input: { ...queryParam } },
      fetchPolicy: "cache-and-network"
    }
  )

  const getFetchProductData = (page) => {
    try {
      productRefecth({ take: 6, skip: 6 * page })
    } catch (err) {
      console.log("err", err)
    }
  }

  const { data: sumData, refetch: refetchSumData } = useQuery(
    SUM_PRODUCTS,
    {
      fetchPolicy: "network-only"
    }
  )

  const { data: categoriesData, loading: categoriesLoading } = useQuery(
    GET_CATEGORIES,
    {
      fetchPolicy: "cache-and-network"
    }
  )

  const [addProductToShoppingCart] = useMutation(ADD_PRODUCT_TO_SHOPPING_CART, {
    refetchQueries: [{ query: SHOPPING_CART }]
  })

  useBread(
    { to: props.match.url, name: "產品列表 (無法與合約品項合併結單)" },
    true
  )

  /**
   * add to shopping cart
   * @param {*} id
   */
  const addToCart = (id, quantity) => {
    props.modal.setCentered(false)
    props.modal.setModalSize("md")
    props.modal.setHeaderText("系統提示")
    props.modal.setSubmitText("加入購物車")
    props.modal.setModalContent(setupModalContent(id, quantity))
    props.modal.setOnSubmit(async () => {
      try {
        await addProductToShoppingCart({
          variables: {
            input: {
              product: id,
              quantity,
              order: shoppingCartId || ""
            }
          }
        })
        props.notify.success("加入購物車成功", {
          onClick: () => {
            if (selectedCompany) {
              props.history.push(`/shoppingcart/${selectedCompany.value}`)
            } else {
              props.history.push("/shoppingcart")
            }
          }
        })
      } catch (e) {
        props.notify.warn("加入購物車失敗")
      }
    })
    props.modal.toggle()
  }

  const setupModalContent = (id, quantity) => {
    const selectedProduct = productData?.products?.data?.find(
      (item) => item.id === id
    )
    return (
      <div>
        <Alert color="warning">
          請確認選取商品資訊是否正確，並按下[加入購物車]繼續
        </Alert>
        <p>商品名稱：{selectedProduct.name}</p>
        <p>
          商品價格：
          <ProductPrice price={selectedProduct.price} />
        </p>
        <p>商品數量：{quantity}</p>
      </div>
    )
  }

  const renderContent = () => {
    return (
      <Row>
        <Col md={3}>
          <ProductCategroies
            selectedCategory={queryParam.category}
            categoriesData={categoriesData.categories.data}
            onSearchNameClick={(name) => {
              setQueryParam({ ...queryParam, name })
              props.history.push(`/product${name ? `?name=${name}` : ""}`)
            }}
            onSearchNumberClick={(productNumber) => {
              setQueryParam({ ...queryParam, productNumber })
              props.history.push(
                `/product${
                  productNumber ? `?productNumber=${productNumber}` : ""
                }`
              )
            }}
            onCategoryChange={(category) => {
              setQueryParam({ ...queryParam, subcategory: category })
              props.history.push(
                `/product${category ? `?cat=${category}` : ""}`
              )
            }}
          />
        </Col>

        <Col md={9}>
          <Switch>
            <Route
              exact
              path={`${props.match.url}`}
              component={() => (
                <ProductList
                  addToCart={addToCart}
                  pagination={pagination}
                  setPagination={setPagination}
                  total={Math.ceil(sumData?.products?.total / 6)}
                  productData={productData.products.data}
                  getFetchProductData={getFetchProductData}
                />
              )}
            />
            <Route
              path={`${props.match.url}/detail/:id`}
              component={() => <ProductDetail addToCart={addToCart} />}
            />
          </Switch>
        </Col>
      </Row>
    )
  }

  if (
    (shoopingCartLoading ||
      productLoading ||
      categoriesLoading ||
      companyLoading ||
      !categoriesData) &&
    !productData
  ) {
    return <Spinner />
  }

  return (
    <>
      {userInfo().role === userRole.SALES_ASSISTANT ||
        (userInfo().role === userRole.SUPERVISOR && (
          <>
            <Row className="mb-3">
              <Col md={12}>
                <FormGroup className="d-flex flex-nowrap">
                  <Col md={8}>
                    <Select
                      placeholder="選擇客戶"
                      isMulti={false}
                      value={selectedCompany}
                      options={getOptions(companyData?.companies.data, [
                        "name"
                      ]).filter((item) => item.label !== "GETECH")}
                      onChange={(option) => {
                        setSelectedCompany(option)
                      }}
                    />
                  </Col>
                  <Col md={4}>
                    <Button
                      disabled={!selectedCompany?.value}
                      onClick={() => {
                        props.history.push(
                          `/shoppingcart/${selectedCompany.value}`
                        )
                      }}
                    >
                      前往客戶購物車
                    </Button>
                  </Col>
                </FormGroup>
              </Col>
            </Row>
            {selectedCompany && renderContent()}
          </>
        ))}
      {userInfo().role === userRole.CUSTOMER_PURCHASER && renderContent()}
    </>
  )
}

export default compose(
  withBasicNotify,
  withBreadcrumb,
  withRouter,
  withModal
)(ProductCl)
